export enum DialogTypesEnum {
    confirm,
    prompt,
    form,
}
